export const SkeletonCard = () => (
  <div className="animate-pulse rounded-[3px] border border-border bg-card p-6">
    <div className="h-4 w-24 rounded-sm bg-muted" />
    <div className="mt-4 h-8 w-40 rounded-sm bg-muted" />
    <div className="mt-6 h-24 rounded-sm bg-muted/75" />
  </div>
);
